import { useContext } from "react";
import userContext from "./context";
import BankBg from "./bank2.jpg";
import { useNavigate } from "react-router-dom";

export default function AllData() {
  const { users } = useContext(userContext);
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(${BankBg})`,
        backgroundSize: "cover",
        minHeight: "100vh",
        paddingTop: "50px",
      }}
    >
      <div className="container">
        <div
          className="card mx-auto shadow-lg"
          style={{
            maxWidth: "50rem",
            borderRadius: "15px",
            border: "none",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
          }}
        >
          <div
            className="card-header text-center text-white"
            style={{
              backgroundColor: "#17a2b8",
              borderRadius: "15px 15px 0 0",
              padding: "20px",
            }}
          >
            <h3 className="mb-0">Bank Ledger: All Data</h3>
          </div>
          <div className="card-body p-4">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Customer Name</th>
                    <th>Email Address</th>
                    <th>Security Pin</th>
                    <th className="text-end">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, i) => (
                    <tr key={i}>
                      <td className="fw-bold text-primary">{user.name}</td>
                      <td>{user.email}</td>
                      <td>
                        <code>{user.password}</code>
                      </td>
                      <td className="text-end fw-bold text-success">
                        ${user.balance}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card-footer text-center py-3">
            <small className="text-muted">
              Total Active Accounts: {users.length}
            </small>
            <br />
            <button
              className="btn btn-sm btn-secondary"
              onClick={() => navigate("/home")}
            >
              Back Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
